import { BudgetExpenseRevision } from 'interfaces/BudgetExpenseLine';
import { api } from '..';

export type MatrixParams = {
  year: number;
  revision?: BudgetExpenseRevision;
  categoryId?: string;
  status?: 'rascunho' | 'fechado';
  costCenterId?: string;
  search?: string;
  page?: number;
  size?: number;
};

export type DraftSummaryParams = {
  year: number;
  costCenterId?: string;
  search?: string;
  page?: number;
  size?: number;
};

export type CreateLineParams = {
  categoryId: string;
  customer: string;
  name: string;
  obs?: string;
  year: number;
  supersedeLegacy?: boolean;
};

export type UpsertCellParams = {
  lineId: string;
  year: number;
  revision: BudgetExpenseRevision;
  month: string;
  valueCents: number;
};

export type CloseRevisionParams = {
  lineId: string;
  year: number;
};

export const matrix = async (params: MatrixParams) => {
  return api.get('/budget-despesas-linhas/matriz', { params });
};

export const draftSummary = async (params: DraftSummaryParams) => {
  return api.get('/budget-despesas-linhas/resumo-revisao', { params });
};

export const createLine = async (params: CreateLineParams) => {
  return api.post('/budget-despesas-linhas', params);
};

export const upsertCell = async (params: UpsertCellParams) => {
  const { lineId, ...body } = params;
  return api.patch(`/budget-despesas-linhas/${lineId}/celula`, body);
};

export const applyFromMonth = async (params: UpsertCellParams) => {
  const { lineId, ...body } = params;
  return api.patch(`/budget-despesas-linhas/${lineId}/aplicar-do-mes`, body);
};

export const closeRevision = async (params: CloseRevisionParams) => {
  const { lineId, ...body } = params;
  return api.post(`/budget-despesas-linhas/${lineId}/fechar`, body);
};

export const deleteLine = async (params: CloseRevisionParams) => {
  const { lineId, year } = params;
  return api.delete(`/budget-despesas-linhas/${lineId}`, {
    params: { year },
  });
};

export const recreateFromPreviousYear = async (year: number) => {
  return api.post('/budget-despesas-linhas/recriar-do-ano-anterior', { year });
};
